import React from 'react'
import '../../../App.css'

import { lexmark } from '../../../data'
import Header from '../../Header'
import { Main, Left, Slika, Right, Ime, Stanje, Kompatibilnost, Ispis, CijenaDiv, Cijena, Mail, Button } from '../../../components/Styling'
import { Link } from 'react-router-dom'

const Lexmark11 = () => {
  return (
    <div>
        <Header />
        <Main>
          <Left>
            <Slika src={lexmark[10].slika} />
          </Left>
          <Right>
            <Ime>
              <p>{lexmark[10].ime}</p>
            </Ime>

            <Stanje>
              <p>Stanje: <b>{lexmark[10].stanje}</b></p>
            </Stanje>

            <Kompatibilnost>
              <p>Kompatibilan sa: <b>{lexmark[10].kompatibilnost}</b></p>
            </Kompatibilnost>

            <Ispis>
              <p>Ispis: <b>{lexmark[10].ispis} stranica</b></p>
            </Ispis>

            <CijenaDiv>
              <Cijena>
                <p>Cijena: <b>{lexmark[10].cijena}</b></p>
              </Cijena>

              <Mail>
                <Link to="/kontakt" style={{width: "100%", marginLeft: "20%"}}>
                  <Button>Kontakt</Button>
                </Link>
              </Mail>
            </CijenaDiv>
          </Right>
        </Main>
    </div>
  )
}

export default Lexmark11